/**
 * @title Delivery page - Freight Option
 * @description The shipping delivery service used to send in the items
 * @image https://storageaccountourimbea2.blob.core.windows.net/tradein2guide/dropoff-carrier.png
 */
import {Card, CardContent, Radio, RadioGroup} from "@mui/material";
import {GlobalLayout, StyledCardActionArea, StyledTypography} from "../../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {FC} from "react";
import {useRecoilValue} from "recoil";

type FreightBoxProps = {
   id: string,
   onClick: () => void,
   image: string,
   title: string,
   description: string,
   selected: boolean,
   children?: React.ReactNode
}

export const FreightBox: FC<FreightBoxProps> = (
   {
      id, onClick, image, title, description, selected, children
   }) => {
   const globalLayout = useRecoilValue(GlobalLayout);
   const classes = useFreightBoxStyles();
   return <RadioGroup name={"shipment"}>
      <Card variant={"outlined"} className={selected ? classes.cardselected : classes.card}
            style={{borderColor: selected ? globalLayout.widgets?.accessBoxBorder || undefined : undefined}}
      >
         <StyledCardActionArea className={classes.root} onClick={onClick}>
            {!globalLayout.disableIcons && <div className={classes.image}>
               <img src={image} className={classes.logo} title={title} alt={'Select drop off method'}/>
            </div>}
            <div className={classes.details} style={{width: '100%'}}>
               <CardContent className={classes.aligned}>
                  <StyledTypography variant={"body1"}>
                     {title}
                  </StyledTypography>
                  <StyledTypography variant={"subtitle1"} sx={{whiteSpace: 'wrap'}}>
                     {description}
                  </StyledTypography>
               </CardContent>
            </div>
            <div className={classes.details}>
               <CardContent className={classes.aligned}>
                  <Radio value={id} style={{
                     color: globalLayout.mainPanel?.textColor || '#000000',
                  }} checked={selected}/>
               </CardContent>
            </div>
         </StyledCardActionArea>
         {children}
      </Card>
   </RadioGroup>
}

const useFreightBoxStyles = makeStyles({
   root: {
      display: 'flex',
      justifyContent: 'space-evenly',
      gap: '5px',
      paddingLeft: '20px',
      height: 'auto !important'
   },
   card: {
      border: '1px solid #f0f0f0',
      backgroundColor: 'inherit'
   },
   cardselected: {
      border: '1px solid #000000',
      backgroundColor: 'inherit',
      borderRadius: 0
   },
   details: {
      display: 'flex',
      flexDirection: 'column',
   },
   content: {
      flex: '1 0 auto',
   },
   aligned: {
      textAlign: 'left',
      paddingLeft: '0',
      paddingRight: '0',
   },
   logo: {
      width: '36px'
   },
   image: {
      width: '60px',
      marginRight: '15px'
   },
   '@media only screen and (max-width: 800px)': {
      image: {
         width: '30px'
      },
   }

})

